import { checkErrorData } from "./utils";

export function createClient(newClient){
    // console.log("FIRED ACTION CREATE CLIENT", newClient)
    return async function(dispatch){
        dispatch({
            type: "CREATE_CLIENT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    page:"clients",
                    data:newClient
                }),
                credentials: 'same-origin',
            }); 
            
            const createdClient = await response.json()
            console.log(createdClient)// createdClient returns new object created

            if(createdClient.id){ // no errors, return new Object
                dispatch({
                    type: "NEW_CLIENT",
                    payload: createdClient
                    
                })
                dispatch({ type: "CREATE_CLIENT_FULFILLED", payload:"" })
                console.log("Client created")
                return "OK"
            } else {
                dispatch({
                    type: "CREATE_CLIENT_ERROR",
                    payload: createdClient.error.message
                    
                })
            }
            throw new Error(createdClient.error.message)
        } catch (err) {
            dispatch({
                type: "CREATE_CLIENT_ERROR",
                payload: err
            })
            throw err
        }
    }
}
export function updateClient(newClient){
    return async function(dispatch){
        dispatch({
            type: "UPDATE_CLIENT_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page: "clients/update",
                    data: newClient
                }),
                credentials: 'same-origin',
            }); 
            
            const res = await response.json()
            console.log(res)

            if(checkErrorData(res, "UPDATE_CLIENT_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_CLIENT",
                    payload: newClient
                })
                dispatch({ type: "UPDATE_CLIENT_FULFILLED", payload: "" })
            }
            
        } catch (err) {
            dispatch({
                type: "UPDATE_CLIENT_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteClient(client){
    return {
        type: "DELETE",
        payload: client
        
    }
}
export function getClientRecoveryActions(boxAssoId, recovery_list){
    console.log('====================================');
    console.log("IN ACTION GET RECOVERY LIST", boxAssoId, recovery_list);
    console.log('====================================');
    // let recoveryIDList = recovery_list.map(item => {
    //     return item.id
    // })
    return {
        type: "GET_CLIENT_RECOVERY",
        payload:  {boxId : boxAssoId, recovery: recovery_list}
        
    }
}

export function getRecoveryList(type = "LATE"){
    return async function(dispatch){ 
        if( type === "LATE" ){
            
            let clients = await getLateClients()
            
            // dispatch({
            //     type: "UPDATE_PAYG_CLIENTS",
            //     payload: {list: clients, info_type: "recovery_info"}
            // })
            dispatch({
                type: "GET_RECOVERY_LIST",
                payload: clients
            })
        } else {
            let clients = await getLateClients(0, 5)
            
            // dispatch({
            //     type: "UPDATE_PAYG_CLIENTS",
            //     payload: {list: clients, info_type: "recovery_info"}
            // })
            dispatch({
                type: "GET_ALMOST_LATE_LIST",
                payload: clients
            })
        }
    }
}

async function getLateClients(min = -100000, max = -1){
    try {
        // const response = await fetch("/recovery/getClientList", {
        const response = await fetch("/recovery/idList", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body:JSON.stringify({
                min,
                max,
                list: "recovery"
            }),
            credentials: 'same-origin',
        });
        const res = await response.json();
        let clients = [];

        res.content.info.map(client => {
            
            // let clientObject = {}
            // client.map((field, index) => {
            //     clientObject[res.content.name[index]] = field
            // })
            // clients.push(clientObject)
            clients.push(client[0])
        })
        // clients = formatDataPayg(clients, "boxAssoId")
        return clients
        
    } catch (error) {
        console.log("GET recovery clients list", error);
        return []
    }
}
    
export function getPaygClients(){
    return async function (dispatch){ // resume list of all clients
        try {
            dispatch({
                type: "GET_PAYG_CLIENTS_START"
            })
            const response = await fetch('/user/resumeinfolist', {
                method: 'GET',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });

            // Check response status before parsing JSON
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP ${response.status}: ${errorText}`);
            }

            const boxIdList = await response.json(); 
            
            let clientList = [];

            boxIdList.content.info.map(client => {
                let clientObject = {}
                client.map((field, index) => {
                    clientObject[boxIdList.content.name[index]] = field
                })
                clientList.push(clientObject)
            })
            
            console.log(clientList); 

            if(clientList.length > 0 ){
                let subscriptionList = clientList.reduce(( sums, item ) => { // nb clients / subscription
                    sums[item.subscriptionID] = (sums[item.subscriptionID] || 0) + 1;
                    return sums;
                 },{});
                 dispatch({
                    type: "GET_SUBSCRIPTIONS_STATS",
                    payload: subscriptionList
                })
            }

            clientList = formatDataPayg(clientList, "boxAssoId")
            // clientList = formatDataPayg(clientList, "idBox")
            
            // Batch dispatches to prevent store.getState() calls during reducer execution
            dispatch({
                type: "GET_PAYG_CLIENTS",
                payload: clientList
            })
            
            // Defer completion dispatch to next tick
            setTimeout(() => {
                dispatch({
                    type: "GET_PAYG_CLIENTS_FULFILLED"
                })
            }, 0)   
        } catch (error) {
            console.log("GET PAYG CLIENTS", error);
            dispatch({
                type: "GET_PAYG_CLIENTS_ERROR",
                payload: error.message || "Failed to fetch clients", // Store serializable string
            })
        }
    }
}

export function getPaygResumeInfo(idList){
    return async function (dispatch){ // resume list of selected clients
        try {
            dispatch({
                type: "GET_PAYG_SELECTED_START"
            })
            const response = await fetch('/user/single/resume/infolist', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({idList}),
                credentials: 'same-origin',
            });

            // Check response status before parsing JSON
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP ${response.status}: ${errorText}`);
            }

            const data = await response.json(); 
            let clientList = [];
            
            data.content.info.map(client => {
                let clientObject = {}
                client.map((field, index) => {
                    clientObject[data.content.name[index]] = field
                })
                clientObject.resume_info = true
                clientList.push(clientObject)
            })          
            console.log(clientList); 

            clientList = formatDataPayg(clientList, "boxAssoId")
            // clientList = formatDataPayg(clientList, "idBox")
            
            // Batch dispatches to prevent store.getState() calls during reducer execution
            dispatch({
                type: "UPDATE_PAYG_CLIENTS",
                payload: {list: clientList, info_type: "resume_info"}
            })
            
            // Defer completion dispatch to next tick
            setTimeout(() => {
                dispatch({
                    type: "GET_PAYG_SELECTED_FULFILLED"
                })
            }, 0)
        } catch (error) {
            console.log("GET PAYG RESUME", error);

            dispatch({
                type: "GET_PAYG_SELECTED_ERROR",
                payload: error.message || "Failed to fetch resume info", // Store serializable string
            })
        }
    }
}

export function getPaygDashboardInfo(idList){
    return async function (dispatch){ // resume list of selected clients
        try {
            dispatch({
                type: "GET_PAYG_SELECTED_START"
            })
            const response = await fetch('/user/single/resume/dashboard', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({idList}),
                credentials: 'same-origin',
            });

            // Check response status before parsing JSON
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP ${response.status}: ${errorText}`);
            }

            const boxIdList = await response.json(); 
            
            let clientList = [];
            boxIdList.content.info.map(client => {
                let clientObject = {}
                client.map((field, index) => {
                    clientObject[boxIdList.content.name[index]] = field
                })
                clientObject.dashboard_info = true
                clientList.push(clientObject)
            })          
            console.log(clientList); 

            clientList = formatDataPayg(clientList, "boxAssoId")
            
            // Batch dispatches to prevent store.getState() calls during reducer execution
            dispatch({
                type: "UPDATE_PAYG_CLIENTS",
                payload: {list: clientList, info_type: "dashboard_info"}
            })
            
            // Defer completion dispatch to next tick
            setTimeout(() => {
                dispatch({
                    type: "GET_PAYG_SELECTED_FULFILLED"
                })
            }, 0)

        } catch (error) {
            console.log("GET PAYG DASHBOARD", error);

            dispatch({
                type: "GET_PAYG_SELECTED_ERROR",
                payload: error.message || "Failed to fetch dashboard info", // Store serializable string
            })
        }
    }
}
export function getSelectedPaygInfo(url, idList, info_type){
    return async function (dispatch){ // resume list of selected clients
        try {
            dispatch({
                type: "GET_PAYG_SELECTED_START"
            })
            const response = await fetch(`/user/single/resume/${url}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({idList}),
                credentials: 'same-origin',
            });
            const text = await response.text();
            if (!response.ok) {
                throw new Error(text || `Request failed ${response.status}`);
            }
            let list;
            try {
                list = JSON.parse(text);
            } catch (parseError) {
                throw new Error(text || 'Invalid response');
            }

            let clientList = [];
            list.content.info.map(client => {
                let clientObject = {}
                client.map((field, index) => {
                    clientObject[list.content.name[index]] = field
                })
                clientObject[info_type] = true
                clientList.push(clientObject)
            })          
            console.log(clientList); 

            clientList = formatDataPayg(clientList, "boxAssoId")
            
            // Batch dispatches to prevent store.getState() calls during reducer execution
            dispatch({
                type: "UPDATE_PAYG_CLIENTS",
                payload: {list: clientList, info_type}
            })
            
            // Defer completion dispatch to next tick
            setTimeout(() => {
                dispatch({
                    type: "GET_PAYG_SELECTED_FULFILLED"
                })
            }, 0)
        } catch (error) {
            console.log("GET PAYG SELECTED ERROR", error);
            const message = (error && typeof error.message === 'string') ? error.message : String(error);
            dispatch({
                type: "GET_PAYG_SELECTED_ERROR",
                payload: message,
            })
        }
    }
}

export function getPaygClientsV2(clients){
    // console.log("FIRED ACTION GET CLIENTS", clients)
    return async function (dispatch){ // resume list of all clients
        try {
            const response = await fetch('/user/paygoboxlist', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            const clients = await response.json(); 
            const correct_client_List = clients.userList.map(client=>{// name & ID inverted in res
                let ID = client.name
                let name = client.id
                return {...client, id : ID, name : name }
                })
            dispatch({
                type: "NEW_PAYG_CLIENTS",
                payload: correct_client_List
            })
            
        } catch (error) {
            console.log("GET PAYG CLIENTS", error);
            // dispatch error
        }
    }
    
}
export function getClient(client_Id){
    // console.log("FIRED ACTION GET CLIENTS", clients)
    return {
        type: "GET_CLIENT",
        payload: client_Id
        
    }
}

function formatDataPayg(list, field = "id"){
    let newList = {}
    if (list) {
        list.map( item =>{
            newList[item[field]] = {
                resume: item 
            }
        })
    }

    return newList
}